import {getInState} from './../helpers/composeReducer.js';
import {pushPath} from 'redux-simple-router';
import {getIdentifier} from '../helpers/api.js';
import {openProblem as openProblemAction, getFirstProblem as getFirstProblemAction} from '../actions/problem.action.js';
import {openReviewsFor} from '../actions/review.action.js';
import {openBookmarkStatusFor} from '../actions/bookmark.action.js';

import { match } from 'react-router';

let unsubscribeFns = {}
let currentPaths = {}

export function initRouteListener (store, url){
    let routes = getInState(store.getState,'helpers.routes');
    let id = getInState(store.getState,'app.id');
    let current_route = {};
    let current_problem = {};
    let unsubscribe = unsubscribeFns[id] || function(){};

    // Unsubscribe if we subscribed before.
    unsubscribe();
    unsubscribe = store.subscribe(() => {
        let route = store.getState().routing;
        let problem = getInState(store.getState,'problem');
        let currentPath = currentPaths[id] || '';

        if (route == current_route && problem == current_problem) return;

        current_problem = problem;
        current_route = route;

        let location = route.path || url;

        if (location) {
            match({routes, location}, (error, redirectLocation, renderProps) => {
                // If the route hasn't changed, no need to proceed.
                if (location != currentPath) {
                    currentPaths[id] = location;
                    onRouteChange(store, renderProps.params);
                } else {
                    checkForUpdateRoute(store, renderProps.params);
                }
            });
        }
    });
    unsubscribeFns[id] = unsubscribe;
}

export function onRouteChange(store, params) {
    // If there's no problem, then get the first problem
    if (!params.problem) {
        getFirstProblem(store, params.chapter);
        return;
    }

    return checkForNewProblem(store, params);
}


function checkForUpdateRoute(store, params) {
    if (!params || params.problem) return false;

    let id_key = getInState(store.getState, 'options.use_id_identifier') ? 'id' : 'name';
    let problem = getInState(store.getState, 'problem');

    if (problem[id_key]) {
        let props = {
            problem: problem[id_key],
            chapter: problem.chapter[id_key]
        }
        return updateRoute(store, props, params);
    }
}

function updateRoute(store, props, params){
    let newPath = getInState(store.getState,'helpers.buildRoute')('problem', {
        chapter : props.chapter,
        problem : props.problem,
        isbn13  : params.isbn13
    });

    store.dispatch(pushPath(newPath, {}, {avoidRouterUpdate:true}));
    //store.dispatch(openReviewsFor(identifier));
}


function checkForNewProblem(store, params){
    if (!params) return false;

    let route = {
        problem : params.problem,
        chapter : params.chapter
    };

    let id_key = getInState(store.getState, 'options.use_id_identifier') ? 'id' : 'name';
    let problem = getInState(store.getState, 'problem');
    let serverLog = getInState(store.getState, 'helpers.logger.serverLog', function(){});
    serverLog(`opening chapter ${route.chapter} problem ${route.problem}`);

    // If the route points to the current chapter/problem, do nothing.
    if (route.problem == problem[id_key] && route.chapter == problem.chapter[id_key]) {
        return true;
    }

    openProblem(store, getIdentifier(
        getInState(store.getState, 'app.id'),
        {
            chapterName: route.chapter,
            id: route.chapter
        }, {
            problemName: route.problem,
            id: route.problem
        })
    );
    return true;
}

function openProblem(store, id){
    store.dispatch(openProblemAction(id));
    //store.dispatch(openReviewsFor(id));
}

function getFirstProblem(store, chapter) {
    store.dispatch(getFirstProblemAction(chapter));
}



// WEBPACK FOOTER //
// ./src/modules/routeListener.js